import { MouseEvent } from "react";

import { useTranslation } from "next-i18next";

import Money from "@/assets/icons/24/Money";
import { SecurityOutlined } from "@/assets/icons/24/SecurityOutlined";
import Spark from "@/assets/icons/24/Spark";
import { GoogleReviewRating } from "@/common/components/GoogleReviewRating";
import { PaymentMethods } from "@/common/components/PaymentMethods";
import { analyticsService } from "@/common/services/analytics/analytics.service";
import { captureMisclick } from "@/common/utils/analytics.utils";
import LokaliseMarkdownText from "@/components/text/LokaliseMarkdownText";
import { showModal } from "@/ui/Modal2";
import { Heading } from "@/ui/cva/Heading";

const USP_LIST = [
  {
    icon: SecurityOutlined,
    text: "pdp:pdp-brand-promise-usp-1-v2",
  },
  {
    icon: Spark,
    text: "pdp:pdp-brand-promise-usp-2-v2",
  },
  {
    icon: Money,
    text: "pdp:pdp-brand-promise-usp-3-v2",
  },
];

export const ProductDetailsBrandPromises = () => {
  const { t } = useTranslation();

  const handleBuyerProtectionClick = (evt: MouseEvent<HTMLAnchorElement>) => {
    evt.preventDefault();

    showModal("pdp-details-modal", {
      title: t("pdp:pdp-buyer-protection-modal-title"),
      text: t("pdp:pdp-buyer-protection-modal-text"),
    });
  };

  return (
    <div
      className="mt-4 bg-flavour-50 p-4 md:mt-0"
      {...captureMisclick(analyticsService.trackClickedBrandPromiseBlock)}
    >
      <span className="flex flex-col space-y-4">
        <div className="flex flex-col space-y-2">
          <Heading as="h5">{t("pdp:pdp-brand-promise-title")}</Heading>
          <span className="flex flex-col space-y-2">
            {USP_LIST.map(usp => (
              <span key={usp.text} className="flex items-center space-x-2">
                <usp.icon className="size-5 h-[1lh] shrink-0 self-start text-brand-500" />
                <LokaliseMarkdownText
                  wrapper="span"
                  lokaliseKey={usp.text}
                  overrides={{
                    a: {
                      props: {
                        className: "underline cursor-pointer",
                        onClick: handleBuyerProtectionClick,
                      },
                    },
                  }}
                  className="text-grey-800"
                />
              </span>
            ))}
          </span>
        </div>
        <hr />
        <div className="flex flex-col space-y-2">
          <Heading as="h5">
            {t("pdp:pdp-brand-promise-trusted-payment-methods")}
          </Heading>
          <PaymentMethods />
        </div>
        <span className="flex items-center space-x-2">
          <span className="font-title text-base">
            {t("pdp:pdp-brand-promise-top-rated")}
          </span>
          <GoogleReviewRating />
        </span>
      </span>
    </div>
  );
};
